import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 15px;
`;

export const Label = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const Value = styled(Typography.Body)<{ $isLink?: boolean }>`
  ${({ $isLink }) =>
    $isLink &&
    css`
      color: ${({ theme }) => theme.palette.system.blue};

      &:hover {
        color: ${({ theme }) => theme.palette.system.deepBlue};
      }
    `}
`;
